import React from 'react';
import { useSelector } from 'react-redux';
import { Spinner } from 'reactstrap';

const AttenteRequete = ({ request_type, str, children }) => {
  // Use useSelector hook to get state from Redux
  const attenteReq = useSelector(
    (state) => state.attenteRequete['ATTENTE_REQUETE' + request_type]
  );

  // Early return pattern for better readability
  if (attenteReq === undefined || !attenteReq) {
    return children;
  }

  return (
    <>
      <Spinner />
    </>
  );
};

export default AttenteRequete;
